import React from "react";
import { Container, Row, Col, Card, Badge, Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import "./Directors.css";

const Directors = () => {
  const data = {
    education: {
      schools: [
        { institution: "Tripura", years: "Class 1-3" },
        { institution: "Bankura Zilla School", years: "Class 4-6" },
        {
          institution: "R.K. Mission, Baranagar, Kolkata",
          years: "Class 7-8 (Higher Secondary)",
        },
        {
          institution: "South Suburbian School Main, Bhowanipore, Kolkata",
          years: "Class 9-11",
        },
      ],
      college: {
        bsc: "B.Sc. (Calcutta University)",
        years:
          "1st Year Charuchandra College, 2nd - 3rd year Bangabasi College",
      },
      correspondence: {
        institution: "Jadavpur University",
        course:
          "Indian Culture Heritage and Cultural Heritage of India (Anthropology as the 4th Subject)",
      },
    },
    languages: [
      {
        name: "English, Bengali, Hindi",
        proficiency: "100% Read, Write and Speak",
        variant: "success",
      },
      //  {
      //    name: "Bengali",
      //    proficiency: "100% Read, Write and Speak",
      //    variant: "success",
      //  },
      //  {
      //    name: "Hindi",
      //    proficiency: "100% Read, Write and Speak",
      //    variant: "success",
      //  },
      {
        name: "Assamese",
        proficiency: "Speak, Read and Understand-50%",
        variant: "warning",
      },
      {
        name: "Naga, HMAR, Paite, Gaite",
        proficiency: "Speak and Understand 25%",
        variant: "secondary",
      },
      {
        name: "Manipuri",
        proficiency: "Speak and Understand 20%",
        variant: "secondary",
      },
      {
        name: "Kashmiri",
        proficiency: "Speak and Understand 50%",
        variant: "warning",
      },
      {
        name: "Rajasthani, Bundelkhand",
        proficiency: "Speak and Understand 20%",
        variant: "secondary",
      },
      {
        name: "Bhojpuri",
        proficiency: "Speak and Understand 50%",
        variant: "warning",
      },
      {
        name: "Panjabi, Dogri",
        proficiency: "Speak and Understand 50%",
        variant: "warning",
      },
      {
        name: "Nepali",
        proficiency: "Speak and Understand 50%",
        variant: "warning",
      },
      {
        name: "Tamil",
        proficiency: "Speak and Understand 10%",
        variant: "danger",
      },
      {
        name: "Urdu",
        proficiency: "Speak and Understand 40%",
        variant: "warning",
      },
    ],
    service: {
      joining:
        //  "Joined Central Intelligence Bureau on 13-01-1969 after passing UPSC Exam in 1968.",
        "Joined the Central Intelligence Bureau on 13-01-1969, after passing the UPSC Exam in 1968, and took the oath of office administered by the President of India, Dr. Rajendra Prasad.",
      training: [
        {
          academy: "NPA (National Police Academy) at Mt. Abu, Rajasthan",
          duration: "January to July 1969",
        },
        {
          academy: "Advance Int. Training at Anand Parbat, New Delhi",
          duration: "August 1969 - February 1970",
        },
      ],
      securityAdvisor:
        "Chief Security advisor for Coal mines and N.T.P.C, MP, UP (2003-2004), covering JAYANT (ASIA's largest coal field) and DODHICHUA, and districts like STIDHI, SHADHOL, ANUPUR, UMARIA, including The REHAND DAM.",
    },
    credentials: [
      {
        year: 1961,
        details: [
          "N.C.C (Air Wing) Best Cadet, winner of Governors Medal (Smt. Padmaja Naidu) West Bengal.",
          "Participated in Republic Day Parade, New Delhi (13th January to 30th January 1961) and NCC Day Parade on 28-01-1961.",
        ],
      },
      {
        year: 1964,
        details: [
          "University Blue Sports (Calcutta): Long jump-14ft. 9 Inch, High Jump-5Ft. 3inch, Javelin throw-86 Ft. 8inch.",
        ],
      },
      {
        year: "1964-1965",
        details: [
          "Completed Flying Training at Behala Flying Club, Kolkata (36 Hours Govt. Scholarship, 14 hours solo).",
          "Obtained Student Pilot Licence from N.C.C. (D.G.C.A.), 1st Bengal Air Sqdn.",
        ],
      },
      {
        year: 1966,
        details: [
          "Fought and killed a leopard bare-handed to save other NCC boys at Volvon Dam, Lonavala. Published in 'The Daily Statesman' (06-06-1966) and 'Himmat' magazine.",
          "Joined Allied Distributors as Sales Representative, dealing with Bengal Potteries (crested crockery for Railways, Hotels, Indian High Commission), BPT tiles to Woodland Nursing Home and Hotel Hindusthan International at Calcutta.",
        ],
      },
      {
        year: "1966-1967",
        details: [
          "Attended Basic Mountaineering Course at H.M.I. Darjeeling under Col. Nandukumar and Field Director Tenzing Norgay.",
        ],
      },
      {
        year: 1970,
        details: [
          "Posted to Gwalior, MP. Covered Airbase Murar, Indergunj Police Station, and districts of MP/UP border with the districts of Vind, Morena, Datia, Dabra, Guna Vander and jhansi (UP, Chirgawn)",
          "Palace Guard of Madhav Rao Sindhiya, the then Youth Congress All India President.",
          "Killed Gopal Daku in an encounter under the leadership of SHO, Mr. V.N. Barbay.",
        ],
      },
      {
        year: 1971,
        details: [
          "Posted to Srinagar, J&K for special operation. Fought in the 1971 (Bangladesh War) and was awarded a **War Cross - SANGRAM MEDAL**.",
          "Detected the largest spy ring 'AL-FATAH' (176 Kashmiri Youths) and was rewarded the **J&K KATHIN-SEVA POLICE MEDAL** in 1974.",
        ],
      },
      {
        year: 1973,
        details: [
          "Advance Mountaineering Course and Rescue operation for Poland Team at C.V.12 Expedition.",
          "Climbed a Vargin Peak (19760 ft.) under H.M.T. Manali, and named it Guha Peak, a name later granted by I.M.F. after the recommendation of the then Principal Sri S.P.Singh.",
        ],
      },
      {
        year: 1974,
        details: [
          "Transferred to Imphal, Manipur with SSB/ARC, covering the Burma (Myanmar) Border, some portion of Mizoram and Nagaland and the entire Barak river area (starting from Tipai Mukh to Karimganj via liribam, Laxmipore, Fulertal, Tukergram).",
          "Attended General Officers' Course at Frontier Academy, Gwaldam, Garwal at 58th Training Center and Demolition & Conversion Course at SSB Training Centre, Tezpur-Soloni Bari which was a night firing couse at Valukpung and included MIG-21 Assimuator Experience at Tezpur Air Base, Assam.",
          "Was a Track-Judge for All India School Games held at Manipur. It was the 1st Manipur Rifle and the Martial was Capt. Banerjee.",
        ],
      },
      {
        year: 1977,
        details: [
          "Received **Kathin Seva Police Medal** after Laldenga surrendered with his 52 followers (like Robonga, Beakbela, Beakchunga, Damkhosai Gangtey).",
          "Opened 9 primary schools as Balbari which covered East, South, and West districts of Manipur.",
        ],
      },
      {
        year: 1981,
        details: [
          "Posted at Baramula, J&K. Found infiltration routes, did the 1st reconnaissance of the Siachen Sector and the area of Kisan Ganga including Kiran Sector with Army, and liaison with UNO officers, CRPF Security Personnel, LU Unit, FSS, the Pravost of CMP (Military Police) and Indian Army.",
          "Received **J&K Kathin Seva Police Medal**.",
        ],
      },
      {
        year: 1984,
        details: [
          "Posted to Kolkata In-Charge of the Counter Intelligence Branch, covering all embassies.",
        ],
      },
      {
        year: 1987,
        details: [
          "Made Kolkata (Dumdum) International Airport (now knows as Netaji Sugbash Chandra Bose) computerized as the immigration In-charge of Calcutta Airport.",
        ],
      },
      {
        year: 1988,
        details: [
          "1st Report on Arms dropping at WB (Purulia) and the missing link of the aircraft of Kimdevi and Peter Devi.",
        ],
      },
      {
        year: 1989,
        details: [
          "Joined SPG Black Cat Commando. Special duty with PM's office and Residence Rajiv Gandhi and President Giani Zail Singh.",
        ],
      },
      {
        year: 1990,
        details: [
          "Special Duty at Imphal, Manipur as OSD, covering Counter Intelligence with entire border area of Assam, Manipur, Nagaland, Mizoram and Myanmar.",
        ],
      },
      {
        year: 1991,
        details: [
          "Posted to Tezpur, Assam. Covered the area up to Dibrugarh and dropping zones of ARC (Dumdum) and Jorhat for MIG Squadron at Tejpur Air Base.",
        ],
      },
      {
        year: 1992,
        details: [
          "Spent 9 days as a ground nut seller at Nakshal Bari Rall Station for a special operation to find links among ALFA, Maobadi, and Naksal Group under guidance of DD, SIB Tezpur which was a special operation of IPS Mr. Dawa Tsring.",
          "Posted to Tawang, Arunachal. Covered the area Bomdila and Tawang sector, starting from Bhalukpung to Bumla, Kapo, Golathoung, Khinjamini and Jimithung, and this was the route of through which Dalai Lama entered India after China attacked Tibet in 1962.",
          "Covered the area of Bhutan Border, dropping planning/Supply/Collection of Intelligence/Evacuation, Meeting with Army Generals for discussion over issues, Flag Meeting, tactical Movement and the deployment of Bofors Guns.",
          "Opened two Observation Posts (O.P'S) Shibani and Usha above 14000ft.",
        ],
      },
      {
        year: 1994,
        details: [
          "Posted at Kolkata HQ, Special Cell, 'G' branch. In-charge of special operations and Freshers Officers Training.",
        ],
      },
      {
        year: 1998,
        details: [
          "Liaison Officer for All India Police Meet held at Salt Lake Stadium which held after 47 years in West Bengal.",
        ],
      },
      {
        year: 1999,
        details: [
          "Posted at North Bengal/Siliguri, looking after Counter Intelligence and Surveillance. Was also in charge for training the officers.",
        ],
      },
      {
        year: 2001,
        details: [
          "Special Operation in Uttar Dinajpur, Dakshin Dinajpur, and Malda. Recovered fake currency and firearms with BSF and Local Police.",
        ],
      },
      {
        year: 2003,
        details: [
          "Posted to Rewa under Bhopal, MP. Covered areas like Rewa, Chatna, Jabalpur, and borders of 36 garh like Penda-Road in the areas of Amarkantak and Chitrakut hills.",
        ],
      },
      {
        year: 2004,
        details: [
          "Received **ANTARIKSH SEVA PADAK** and retired on 31-01-2005 from S18, Bhopal, MP.",
        ],
      },
      {
        year: 2015,
        details: [
          "Visited Bangladesh as India Team Manager of Handball Game at Chittaganj Stadium, Dhaka.",
        ],
      },
    ],
    vvipDuties: {
      pms: [
        "Mrs. Indira Gandhi",
        "Mr. Rajiv Gandhi",
        "Mr. V.P.Singh",
        "Mr. Chandra Sekhar",
        "Mr. Atal Bihari Vajpayee",
      ],
      presidents: [
        "Fakhruddin Ali Ahmed",
        "Giani Zail Singh",
        "Pranab Mukherjee (as Finance Minister)",
      ],
      vicePresidents: ["Bharron Singh Shekhawat"],
      governors: "J&K, WB, Odissa, Nagaland, Manipur",
      foreignPMs: [
        "Pakistan (Mr. J.A.Bhutta when meeting with Indira Gandhi at Reffate, Shimla)",
        "Bangladesh",
        "Nepal",
        "UK",
        "Bhutan",
      ],
    },
    socialWork: [
      "Helped around 45 couples for marriage in poor families.",
      "Helped over 37 boys and girls for completing and obtaining certificates in School and College levels.",
      "Organizing seminars with local handicraft artists and manufacturers every year.",
      "Organizing 'BAUL MELA' (Pro) Singers for last 37 years.",
      "Organizing Tours-Religious/Cultural for 12 years.",
      "Organizing Rock Climbing and Nature Study Courses for last 18 years for students above 14 years of age.",
      "Organizing tours with senior citizens for more than 12 years.",
      "Organizing Arts and Photography Exhibition in every alternate year.",
      "Arranging Dog Shows with local pet dogs.",
      "Experience in the field of Organic Agriculture (Noni, Dragon Fruits, Honey, Ghee, Mushroom) in remote areas of West Bengal and Jharkhand.",
    ],
  };

  const leadershipTeam = {
    chairman: {
      name: "Benugopal Ghosh",
      designation: "Chairman",
      place: "Kolkata, West Bengal",
      previousRole:
        "Retd. Asst. Director, Central Int. Bureau M.H.A. Govt. of India (Ex-SSB, ARC, S.PG)",
      image: "/images/Benugopal_Ghosh.png",
      bio: `A veteran of the Central Intelligence Bureau and a decorated officer,
    he has dedicated his life to national service and social welfare.
    From battling dacoits to leading special operations in conflict zones,
    his career is a testament to extraordinary courage and commitment.`,
    },

    presidents: [
      {
        name: "S J Rahman",
        profession: "National Social Worker",
        designation: "National President",
        registrationId: "MAF-WB-344/25",
        district: "Paschim Bardhaman",
        state: "West Bengal",
        image: "/images/S_J_Rahman.jpg",
      },
    ],

    vicePresidents: [
      {
        name: "Thungnoori Balaraju",
        profession: "Supreme Court Advocate",
        designation: "National Vice President",
        registrationId: "MAF-TG-353/25",
        district: "Malkajgiri",
        state: "Telangana",
        image: "/images/Thungnoori_Balaraju.jpg",
      },
      {
        name: "Samarendra Kr Panda",
        profession: "Actor",
        designation: "National Vice President",
        registrationId: "MAF-OD-356/25",
        district: "Balasore",
        state: "Odisha",
        image: "/images/Samarendra_Kr_Panda.jpg",
      },
      {
        name: "Ramesh Ch Ojha",
        profession: "Central Railway Employee",
        designation: "National Vice President",
        registrationId: "MAF-WB-417/25",
        district: "Paschim Bardhaman",
        state: "West Bengal",
        image: "/images/Ramesh_Ch_Ojha.jpg",
      },
      {
        name: "Dr. Binod Kumar Singh",
        profession: "Doctor",
        designation: "National Vice President",
        registrationId: "MAF-BR-1150/26",
        district: "Arwal",
        state: "Bihar",
        image: "/images/bksingh.jpeg",
      },
    ],
    legalAdvisors: [
      {
        name: "Prerna Sanjeev Singh",
        profession: "Supreme Court Advocate",
        designation: "National Legal Advisor",
        registrationId: "MAF-DL-489/25",
        district: "Dhanbad",
        state: "Jharkhand",
        image: "/images/Prerna_Sanjeev_Singh.jpeg",
      },
      {
        name: "Shikhar Srivastava",
        profession: "Supreme Court Advocate",
        designation: "National Legal Advisor",
        registrationId: "MAF-DL-490/25",
        district: "East Delhi",
        state: "Delhi",
        image: "/images/Shikhar_Srivastava.jpeg",
      },
      {
        name: "K V V Vara Prasad",
        profession: "Advocate",
        designation: "National Legal Advisor",
        registrationId: "MAF-AP-1088/26",
        district: "Visakhapatnam",
        state: "Andhra Pradesh ",
        image: "/images/K_V_V_Vara_Prasad.jpeg",
      },
    ],
    mediaSecretary: [
      {
        name: "Umesh Chand Sharma",
        profession: "Social Worker",
        designation: "National Media Secretary",
        registrationId: "MAF-UP-588/25",
        district: "Ghaziabad",
        state: "Uttar Pradesh",
        image: "/images/Umesh_Chand_Sharma.jpeg",
      },
    ],
    jointSecretary: [
      {
        name: "Kothalanka Buwanesshwari",
        profession: "Social Worker",
        designation: "National Joint Secretary",
        registrationId: "MAF-AP-568/25",
        district: "Visakhapatnam",
        state: "Andhra Pradesh ",
        image: "/images/Kothalanka_Buwanesshwari.png",
      },
    ],
    generalSecretary: [
      {
        name: "Rajkumar Dey Sarkar",
        profession: "Businessman",
        designation: "National General Secretary",
        registrationId: "MAF-WB-328/25",
        district: "Bankura",
        state: "West Bengal",
        image: "/images/Rajkumar_Sarkar.jpeg",
      },
    ],
    executiveMembers: [
      {
        name: "Papun Paul",
        profession: "International Kungfu Master",
        designation: "National Executive Member",
        registrationId: "MAF-WB-327/25",
        district: "Paschim Bardhaman",
        state: "West Bengal",
        image: "/images/Papun_Paul.jpg",
      },
      {
        name: "Anar Babu Edupuganti",
        profession: "Social Worker",
        designation: "National Executive Member",
        registrationId: "MAF-AP-584/25",
        district: "Visakhapatnam",
        state: "Andhra Pradesh",
        image: "/images/ANAR_BABU_EDUPUGANTI.jpg",
      },
      // {
      //   name: "Jonnakuti Vijay Kumar",
      //   profession: "Social Worker",
      //   designation: "National Executive Member",
      //   registrationId: "MAF-AP-1011/25",
      //   district: "Visakhapatnam",
      //   state: "Andhra Pradesh",
      //   image: "/images/JONNAKUTI_VIJAY_KUMAR.jpeg",
      // },
    ],
  };

  return (
    <>
      <Helmet>
        <title>National Governing Body | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Meet the National Governing Body of Manav Adhikar Forum, dedicated to protecting human rights across India."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, human rights, India, governing body, leadership, advocacy"
        />
        <link rel="canonical" href="https://manavadhikarforum.in/Directors" />
      </Helmet>

      <Container className="directors-page py-5" style={{ padding: "0 12px" }}>
        {/* Header Section */}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h1
                className="text-center page-title"
                style={{ color: "#1a5276", fontWeight: "bold" }}
              >
                National Governing Body
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "15%",
                  }}
                ></div>
              </h1>
            </div>
            <p className="intro-text-director ">
              The Manav Adhikar Forum governing bodies are elected by the
              General Assembly every three years for a one-year term. The last
              election was held on 31st March 2025 in Kolkata, West Bengal,
              India.
            </p>
            <p className="intro-text-director">
              The governing body consists of the following representatives from
              MAF National Members:
            </p>
            <div className="">
              <ul className="position-list">
                <li>One Chairman</li>
                <li>One President</li>
                <li>Six Vice Presidents</li>
                <li>One Working President</li>
                <li>One General Secretary</li>
                <li>Two Organization Secretary</li>
                <li>Four Joint Secretary</li>
                <li>Three Legal Advisor</li>
                <li>One Treasurer</li>
                <li>4 Media Secretary</li>
                <li>One Spokesman</li>
                <li>Four Executive Members</li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Chairman Section */}
        <Row className="mb-5 chairman-section">
          <Col md={4} className="text-center mb-3">
            <div className="profile-image-container">
              <img
                src={leadershipTeam.chairman.image}
                alt={leadershipTeam.chairman.name}
                className="profile-img"
              />
            </div>
          </Col>
          <Col md={8} className="chairman-info-center.">
            <h2 className="chairman-name">{leadershipTeam.chairman.name}</h2>
            <h4 className="designation">
              {leadershipTeam.chairman.designation}
            </h4>
            <p className="location">{leadershipTeam.chairman.place}</p>
            <p className="previous-role">
              {leadershipTeam.chairman.previousRole}
            </p>
            <div className="bio-section mt-4">
              <h5>Background</h5>
              <p>{leadershipTeam.chairman.bio}</p>
              <a href="#full-profile" className="btn btn-outline-primary mt-2">
                Read more about his life
              </a>
            </div>
          </Col>
        </Row>

        {/* Vice Presidents Section */}
        {/* <Row className="mb-5">
          <Col>
            <h2 className="section-title text-center">Vice Presidents</h2>
            <Row>
              {leadershipTeam.vicePresidents.map((vp, index) => (
                <Col key={index} md={6} lg={3} className="mb-4">
                  <Card key={index} className="h-100 vice-president-card">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="text-center">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row> */}

        {/*National President Section*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National President
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container">
              {leadershipTeam.presidents.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>
        {/*Vice Presidents Section*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National Vice Presidents
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container">
              {leadershipTeam.vicePresidents.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/*National General Secretary*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National General Secretary
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container ">
              {leadershipTeam.generalSecretary.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/*National Joint Secretary*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National Joint Secretary
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container ">
              {leadershipTeam.jointSecretary.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/*Legal Advisors Section*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National Legal Advisors
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container ">
              {leadershipTeam.legalAdvisors.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/*National Media Secretary*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National Media Secretary
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container ">
              {leadershipTeam.mediaSecretary.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/*National Executive Member*/}
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h2 className="section-title text-center">
                National Executive Members
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "18%",
                  }}
                ></div>
              </h2>
            </div>
            <div className="vice-presidents-container ">
              {leadershipTeam.executiveMembers.map((vp, index) => (
                <Card key={index} className="vice-president-card">
                  <div className="card-content-wrapper">
                    <div className="vp-image-container">
                      <img
                        src={vp.image}
                        alt={vp.name}
                        className="vp-profile-img"
                      />
                    </div>
                    <Card.Body className="vp-details-container">
                      <h5 className="vp-name">{vp.name}</h5>
                      <p className="vp-profession">{vp.profession}</p>
                      <p className="vp-designation">{vp.designation}</p>
                      <div className="vp-details">
                        <p>
                          <strong>Registration ID:</strong> {vp.registrationId}
                        </p>
                        <p>
                          <strong>District:</strong> {vp.district}
                        </p>
                        <p>
                          <strong>State:</strong> {vp.state}
                        </p>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/* Full Profile Section */}
        <div className="profile-container p-4" id="full-profile">
          <div>
            <div className="profile-header text-center mb-4">
              <h2 className="fw-semibold" style={{ color: "#1a5276" }}>
                Life & Achievements
              </h2>
              <p className="lead" style={{ color: "#1a5276" }}>
                A comprehensive overview of a remarkable career and personal
                journey of our chairman.
              </p>
            </div>
            <Row className="g-4">
              {/* Education Section */}
              <Col md={6} lg={6}>
                <Card className="h-100 shadow-sm border-0 profile-card education-card">
                  <Card.Header className="bg-primary text-white text-center">
                    <h3 className="m-0">
                      <i className="bi bi-book me-2"></i>Education
                    </h3>
                  </Card.Header>
                  <Card.Body className="d-flex flex-column">
                    <div className="mb-3">
                      <h6
                        className="card-subtitle mb-2 text-muted text-center"
                        style={{ fontWeight: 600 }}
                      >
                        Schooling
                      </h6>
                      <ul className="list-unstyled">
                        {data.education.schools.map((item, index) => (
                          <li key={index}>
                            <strong>{item.institution}</strong>: {item.years}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mb-3">
                      <h6
                        className="card-subtitle mb-2 text-muted text-center"
                        style={{ fontWeight: 600 }}
                      >
                        College
                      </h6>
                      <p className="mb-1">
                        <strong>{data.education.college.bsc}</strong>
                      </p>
                      <p className="mb-0 text-secondary">
                        {data.education.college.years}
                      </p>
                    </div>
                    <div>
                      <h6
                        className="card-subtitle mb-2 text-muted text-center"
                        style={{ fontWeight: 600 }}
                      >
                        Correspondence Continuous Education
                      </h6>
                      <p className="mb-0">
                        <strong>
                          {data.education.correspondence.institution}
                        </strong>
                      </p>
                      <p className="mb-0 text-secondary">
                        {data.education.correspondence.course}
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Service Section */}
              <Col md={6} lg={6}>
                <Card className="h-100 shadow-sm border-0 profile-card service-card">
                  <Card.Header className="bg-info text-white text-center align-items-center">
                    <h3 className="m-0">
                      <i className="bi bi-shield-check me-2"></i>Service
                    </h3>
                  </Card.Header>
                  <Card.Body className="d-flex flex-column">
                    <p className="mb-3">
                      <i className="bi bi-clipboard-check me-2"></i>
                      {data.service.joining}
                    </p>
                    <div className="mb-3">
                      <h6
                        className="card-subtitle mb-2 text-muted text-center"
                        style={{ fontWeight: 600 }}
                      >
                        Training
                      </h6>
                      <ul className="list-unstyled">
                        {data.service.training.map((item, index) => (
                          <li key={index}>
                            <i className="bi bi-mortarboard me-2"></i>
                            <strong>{item.academy}</strong>: {item.duration}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <p className="mb-0">
                      <i className="bi bi-person-fill-gear me-2"></i>
                      <strong>Security Advisor:</strong>{" "}
                      {data.service.securityAdvisor}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              {/* Languages Section */}
              <Col xs={12}>
                <Card className="h-100 shadow-sm border-0 profile-card languages-card">
                  <Card.Header className="bg-dark text-white text-center">
                    <h3 className="m-0">
                      <i className="bi bi-translate me-2 ="></i>Linguistic
                      Proficiency
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <Row className="g-3">
                      {" "}
                      {/* Use a responsive grid for two columns */}
                      {data.languages
                        .slice(0, Math.ceil(data.languages.length / 2))
                        .map((lang, index) => (
                          <Col md={6} key={index}>
                            <p className="mb-0">
                              <i className="bi bi-check-circle-fill me-2 text-primary"></i>
                              <strong>{lang.name}:</strong> {lang.proficiency}
                            </p>
                          </Col>
                        ))}
                      {data.languages
                        .slice(Math.ceil(data.languages.length / 2))
                        .map((lang, index) => (
                          <Col md={6} key={index}>
                            <p className="mb-0">
                              <i className="bi bi-check-circle-fill me-2 text-primary"></i>
                              <strong>{lang.name}:</strong> {lang.proficiency}
                            </p>
                          </Col>
                        ))}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              {/* Credentials and Achievements Section */}
              <Col xs={12}>
                <Card className="shadow-lg border-0 profile-card achievements-card">
                  <Card.Header className="bg-success text-white text-center">
                    <h3 className="m-0">
                      <i className="bi bi-award me-2"></i>Credentials &
                      Achievements
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <Accordion defaultActiveKey="0" alwaysOpen>
                      {data.credentials.map((cred, index) => (
                        <Accordion.Item key={index} eventKey={index.toString()}>
                          <Accordion.Header className="accordion-header-custom">
                            <strong className="" style={{ color: "#28a745" }}>
                              {cred.year}
                            </strong>
                          </Accordion.Header>
                          <Accordion.Body>
                            <ul className="list-unstyled">
                              {cred.details.map((detail, dIndex) => (
                                <li key={dIndex} className="mb-2">
                                  <i className="bi bi-chevron-right me-2 text-success"></i>
                                  {detail}
                                </li>
                              ))}
                            </ul>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </Card.Body>
                </Card>
              </Col>

              {/* VVIP Duties Section */}
              <Col md={6} lg={6}>
                <Card className="h-100 shadow-sm border-0 profile-card vvip-duties-card">
                  <Card.Header className="bg-warning text-dark text-center">
                    <h3 className="m-0">
                      <i className="bi bi-person-lines-fill me-2"></i>VVIP
                      Duties
                    </h3>
                  </Card.Header>
                  <Card.Body className="d-flex flex-column">
                    <div className="mb-3">
                      <h6 className="card-subtitle mb-2 text-muted">
                        <i className="bi bi-person me-2"></i>Prime Ministers
                      </h6>
                      <p className="mb-0">{data.vvipDuties.pms.join(", ")}</p>
                    </div>
                    <div className="mb-3">
                      <h6 className="card-subtitle mb-2 text-muted">
                        <i className="bi bi-person-fill-check me-2"></i>
                        Presidents
                      </h6>
                      <p className="mb-0">
                        {data.vvipDuties.presidents.join(", ")}
                      </p>
                    </div>
                    <div className="mb-3">
                      <h6 className="card-subtitle mb-2 text-muted">
                        <i className="bi bi-person-plus me-2"></i>
                        Vice-Presidents
                      </h6>
                      <p className="mb-0">
                        {data.vvipDuties.vicePresidents.join(", ")}
                      </p>
                    </div>
                    <div className="mb-3">
                      <h6 className="card-subtitle mb-2 text-muted">
                        <i className="bi bi-buildings me-2"></i>Governors
                      </h6>
                      <p className="mb-0">{data.vvipDuties.governors}</p>
                    </div>
                    <div>
                      <h6 className="card-subtitle mb-2 text-muted">
                        <i className="bi bi-globe me-2"></i>Foreign PMs
                      </h6>
                      <p className="mb-0">
                        {data.vvipDuties.foreignPMs.join(", ")}
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Social Work Section */}
              <Col md={6} lg={6}>
                <Card className="h-100 shadow-sm border-0 profile-card social-work-card">
                  <Card.Header className="bg-danger text-white text-center">
                    <h3 className="m-0">
                      <i className="bi bi-heart-fill me-2"></i>Social Work &
                      Hobbies
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <ul className="list-unstyled">
                      {data.socialWork.map((item, index) => (
                        <li key={index} className="mb-2">
                          <i className="bi bi-check-circle-fill me-2 text-danger"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Directors;
